import {ExamModule, UserModule} from '@cp/model';

export interface ExamModuleSelected extends ExamModule {
  userModule?: UserModule;
}

function buildOneExamModuleSelected(examModule: ExamModule, userModule?: UserModule): ExamModuleSelected {
  return {
    ...examModule,
    userModule,
  };
}

export function buildManyExamModuleSelected(
  examModules: ExamModule[],
  userModules: UserModule[],
): ExamModuleSelected[] {
  return examModules.map((examModule) =>
    buildOneExamModuleSelected(
      examModule,
      userModules.find((userModule) => userModule.moduleId === examModule.id),
    ),
  );
}
